export default __webpack_public_path__ + "static/media/madame_side.e6a30d5e.jpg";